import { type Feed, feedSchema } from "@/schemas";
import { filteredArray } from "@/schemas/utils";

import { QueryKeys } from "../../query-keys";
import { importEntities } from "../index";

/**
 * Import feeds to the global cache.
 *
 * @param feeds - array of Feeds
 */
function importFeeds(feeds: Feed[]) {
  const parsedResult = filteredArray(feedSchema).safeParse(feeds);
  if (parsedResult.success) {
    importEntities(QueryKeys.feeds.global, parsedResult.data);
  }
}

export { importFeeds };
